import React from 'react';
import { Tooltip } from 'antd';
import moment from 'moment-timezone';

const UTCTooltip = ({ date }: { date: string | number | Date }) => {
  const parsedDate = moment(date);

  if (!parsedDate.isValid()) {
    return null;
  }

  const timezone = moment.tz.guess();

  return (
    <Tooltip title={`UTC ${moment.utc(date).format('HH:mm:ss MM/DD/YYYY')}`}>
      {moment.utc(date).tz(timezone).format('MMM D, YYYY, h:mm A')}
    </Tooltip>
  );
};

export default UTCTooltip;
